import axios from "axios";

export function makeSearchParams(queryText) {
    return {
        query: queryText
    }
}
function toLine(name) {
    return name.replace(/([A-Z])/g,"_$1").toUpperCase();
}
export async function getData(api,query,willPage=0,order="",direct="",startTime=0,endTime=0) {
    let out = {};
    let first = 20;
    let skip = 0;

    let searchAddress="";
    let searchToken="";

    let isSubquery=api.indexOf("index-api.onfinality.io")!==-1

    if(!direct){
        direct="desc";
    }
    if(!order){
        order="blockTimestamp";
    }

    if(isSubquery){
        query.query=query.query.replaceAll("?nodes{","nodes{");
        query.query=query.query.replaceAll("?nodes}","}");
        query.query=query.query.replaceAll("?skip","offset");
        query.query=query.query.replaceAll("?where","filter");

        query.query=query.query.replaceAll("?in@",":{in:[");
        query.query=query.query.replaceAll("?in|","]}");
        query.query=query.query.replaceAll("?\"","\"");

        query.query=query.query.replaceAll("?eq@",":{equalTo:");
        query.query=query.query.replaceAll("?eq|","}");

        query.query=query.query.replaceAll("?neq@",":{notEqualTo:");
        query.query=query.query.replaceAll("?neq|","}");


        if(order && direct){
            query.query=query.query.replaceAll("?order","orderBy: "+toLine(order)+"_"+direct.toUpperCase()+"\n");
        }

        if(startTime || endTime){
            if(query.query.indexOf("$openTime|")!==-1){
                query.query=query.query.replaceAll("$openTime|",`openTimestamp:{greaterThanOrEqualTo:\"${startTime}\",lessThan: \"${endTime}\"}`);
            }else if(query.query.indexOf("$blockTime|")!==-1){
                query.query=query.query.replaceAll("$blockTime|",`blockTimestamp:{greaterThanOrEqualTo:\"${startTime}\",lessThan: \"${endTime}\"}`);
            }else if(query.query.indexOf("timestamp")!=-1){
                query.query=query.query.replaceAll("$timestamp|",`timestamp:{greaterThanOrEqualTo:\"${startTime}\",lessThan: \"${endTime}\"}`);
            }
        }

        if(query.query.indexOf("$blockTimeAll")!==-1){
            query.query=query.query.replaceAll("$blockTimeAll|",`blockTimestamp:{greaterThanOrEqualTo:\"0\"}`);
        }


    }else{
        query.query=query.query.replaceAll("?nodes{","");
        query.query=query.query.replaceAll("?nodes}","");
        query.query=query.query.replaceAll("?where","where");

        query.query=query.query.replaceAll("?skip","skip");

        query.query=query.query.replaceAll("?in@","_in:[");
        query.query=query.query.replaceAll("?in|","]");
        query.query=query.query.replaceAll("?\"","\"");

        query.query=query.query.replaceAll("?eq@",":");
        query.query=query.query.replaceAll("?eq|","");

        query.query=query.query.replaceAll("?neq@","_not:");
        query.query=query.query.replaceAll("?neq|","");

        if(startTime || endTime){
            if(query.query.indexOf("$openTime|")!==-1){
                query.query=query.query.replaceAll("$openTime|",`openTimestamp_gte: ${startTime}, openTimestamp_lt: ${endTime}`);
            }else if(query.query.indexOf("$blockTime|")){
                query.query=query.query.replaceAll("$blockTime|",`blockTimestamp_gte: ${startTime}, blockTimestamp_lt: ${endTime}`);
            }else if(query.query.indexOf("$timestamp|")){
                query.query=query.query.replaceAll("$timestamp|",`timestamp_gte: ${startTime}, timestamp_lt: ${endTime}`);
            }
        }

        if(query.query.indexOf("$blockTimeAll|")!==-1){
            query.query=query.query.replaceAll("$blockTimeAll|",`blockTimestamp_gte: 0`);
        }


        if(order){
            query.query=query.query.replaceAll("?order","orderBy: "+order+"\n    orderDirection: "+direct);
        }
    }

    while (true) {

        let newQuery = {
            query: ""
        };
        if(willPage>0){
            skip=(willPage-1)*first
        }
        newQuery.query = query.query.replaceAll("$first", first);
        newQuery.query = newQuery.query.replaceAll("$skip", skip+"");


        let res=[];
        try{
            res = await axios.post(api, newQuery);
        }catch (e){
            console.log("error is1",e);
            // alert(JSON.stringify(e));
            throw e;
        }

        if (!res || !res.data || !res.data.data) {
            break;
        }
        let willContinue = false;


        for (let i in res.data.data) {
            if (!out[i]) {
                out[i] = [];
            }

            let resItem=[];
            if(isSubquery){
                resItem=res.data.data[i].nodes;
            }else{
                resItem=res.data.data[i];
            }

            out[i] = out[i].concat(resItem);
            if (resItem.length >= first) {
                willContinue = true;
            }
            // console.log("will continue",willContinue,resItem.length,first);
        }

        if (willContinue && willPage==0) {
            skip += first;
        } else {
            break;
        }
    }

    return out;

}

export async function getDataSimple(api,query,startTime=0,endTime=0){
    let isSubquery=api.indexOf("index-api.onfinality.io")!==-1
    if(isSubquery){
        query.query=query.query.replaceAll("?nodes{","nodes{");
        query.query=query.query.replaceAll("?nodes}","}");
        query.query=query.query.replaceAll("?skip","offset");
        query.query=query.query.replaceAll("?where","filter");

        query.query=query.query.replaceAll("?in@",":{in:[");
        query.query=query.query.replaceAll("?in|","]}");
        query.query=query.query.replaceAll("?\"","\"");

        query.query=query.query.replaceAll("?eq@",":{equalTo:");
        query.query=query.query.replaceAll("?eq|","}");

        query.query=query.query.replaceAll("?neq@",":{notEqualTo:");
        query.query=query.query.replaceAll("?neq|","}");


        if(startTime || endTime){
            if(query.query.indexOf("$openTime|")!==-1){
                query.query=query.query.replaceAll("$openTime|",`openTimestamp:{greaterThanOrEqualTo:\"${startTime}\",lessThan: \"${endTime}\"}`);
            }else if(query.query.indexOf("$blockTime|")!==-1){
                query.query=query.query.replaceAll("$blockTime|",`blockTimestamp:{greaterThanOrEqualTo:\"${startTime}\",lessThan: \"${endTime}\"}`);
            }
        }


    }else{
        query.query=query.query.replaceAll("?nodes{","");
        query.query=query.query.replaceAll("?nodes}","");
        query.query=query.query.replaceAll("?where","where");

        query.query=query.query.replaceAll("?skip","skip");

        query.query=query.query.replaceAll("?in@","_in:[");
        query.query=query.query.replaceAll("?in|","]");
        query.query=query.query.replaceAll("?\"","\"");

        query.query=query.query.replaceAll("?eq@",":");
        query.query=query.query.replaceAll("?eq|","");

        query.query=query.query.replaceAll("?neq@","_not:");
        query.query=query.query.replaceAll("?neq|","");

        if(startTime || endTime){
            if(query.query.indexOf("$openTime|")!==-1){
                query.query=query.query.replaceAll("$openTime|",`openTimestamp_gte: ${startTime}, openTimestamp_lt: ${endTime}`);
            }else if(query.query.indexOf("$blockTime|")){
                query.query=query.query.replaceAll("$blockTime|",`blockTimestamp_gte: ${startTime}, blockTimestamp_lt: ${endTime}`);
            }
        }

    }

    try{
        let res = await axios.post(api, query);
        return res.data.data;
    }catch (e){
        console.log("error is1",e);
        // alert(JSON.stringify(e));
        throw e;
    }

}
